/** ACC 100 vs EVA 0 = 95%; +10 ACC or EVA changes the roll by five percentage points. */
export function hitChance(acc: number, eva: number, version: 1 | 2 | 3 = 2): number {
  return version === 1 ? Math.max(0.5, Math.min(1, 0.95 + (acc - eva) / 1000)) : Math.max(0.5, Math.min(0.99, 0.95 + (acc - 100 - eva) / 200));
}

export interface MoraleMember { kind: string; slot: string; role: string; alive: boolean }
/** Tactical morale resets each battle. Infected and structures do not have crew morale. */
export function battleMorale(members: MoraleMember[]): { score: number; atkPct: number; commander: boolean; support: boolean; losses: number } | null {
  const crew = members.filter(m => m.kind === "unit");
  if (!crew.length) return null;
  const commander = crew.some(m => m.alive && m.slot === "commander");
  const support = crew.some(m => m.alive && (m.slot === "s1" || m.slot === "s2"));
  const losses = crew.filter(m => !m.alive).length;
  const score = Math.max(0, Math.min(100, 50 + (commander ? 10 : 0) + (support ? 10 : 0) - losses * 15));
  return { score, atkPct: (score - 50) / 5, commander, support, losses };
}
